import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import { TrackImpression, track } from 'lib/analytics'
import { babylistUrl, storeCategoryPath } from 'lib/urls'
import { getCategoryWithChildrenBySlug } from 'store/reducers'
import { maybeFetchChildCategoryProducts as maybeFetchChildCategoryProductsAction } from 'store/actions'
import { getRefFromURL } from 'utils'
import { useShow } from 'src/routes/(shop)/api/categories'
import PlacementsInterstitialModal from 'components/modal/PlacementsInterstitialModal'
import { PLACEMENT_INTERSTITIAL_UNIT } from 'lib/placements/units'
import { LeafCategoryPage } from './leaf-category-page'
import ParentCategoryPage from './parent-category-page'

export const BaseCategoryPage = ({
  categorySlug,
  location,
  maybeFetchChildCategoryProducts,
}) => {
  const ref = getRefFromURL()
  const { isLoading, data } = useShow(categorySlug)

  const eventLocation =
    ref === track.EventLocation.CHECKLIST.toLowerCase()
      ? track.EventLocation.CHECKLIST_CATEGORY
      : track.EventLocation.STORE

  if (isLoading) {
    return null
  }

  const currentCategory = data

  return (
    <TrackImpression
      eventProperties={{
        event: track.storeCategoryViewed,
        eventLocation,
        storeCategorySlug: currentCategory.urlSlug,
        storeCategoryName: currentCategory.title,
        isLeafCategory: !currentCategory?.children?.length,
      }}
    >
      <div>
        <Helmet
          meta={[
            {
              name: 'description',
              content: currentCategory.seoDescription,
            },
          ]}
          title={currentCategory.seoTitle}
        >
          <link
            href={babylistUrl(storeCategoryPath(currentCategory.urlSlug))}
            rel="canonical"
          />
        </Helmet>
        {currentCategory.children && currentCategory.children.length ? (
          <ParentCategoryPage
            activeCategory={currentCategory}
            key={currentCategory.urlSlug}
            location={location}
            maybeFetchChildCategoryProducts={maybeFetchChildCategoryProducts}
          />
        ) : (
          <LeafCategoryPage
            category={currentCategory}
            key={currentCategory.urlSlug}
            location={location}
          />
        )}
      </div>
      <PlacementsInterstitialModal
        eventLocation={track.EventLocation.STORE_MINUS_CATEGORY}
        unitId={PLACEMENT_INTERSTITIAL_UNIT}
      />
    </TrackImpression>
  )
}

BaseCategoryPage.propTypes = {
  categorySlug: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  activeCategory: PropTypes.shape({
    children: PropTypes.node,
    /* eslint-disable-next-line react/forbid-prop-types */
    guides: PropTypes.object,
    id: PropTypes.number,
    imageUrl: PropTypes.string,
    path: PropTypes.string,
    teaser: PropTypes.string,
    title: PropTypes.string,
    urlSlug: PropTypes.string,
    isSortable: PropTypes.bool,
    slugSet: PropTypes.arrayOf(PropTypes.string),
    seoDescription: PropTypes.string,
    seoTitle: PropTypes.string,
  }).isRequired,
  maybeFetchChildCategoryProducts: PropTypes.func.isRequired,
}

const mapStateToProps = (state, ownProps) => {
  const { categorySlug } = ownProps.params

  return {
    activeCategory: getCategoryWithChildrenBySlug(state, categorySlug),
    categorySlug,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  maybeFetchChildCategoryProducts: () =>
    dispatch(
      maybeFetchChildCategoryProductsAction(ownProps.params.categorySlug)
    ),
})

const ConnectedCategoryPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(BaseCategoryPage)

// eslint-disable-next-line import/no-default-export
export default ConnectedCategoryPage
export const CategoryPage = ConnectedCategoryPage
